<h1 mat-dialog-title>Configure Endpoint: {{data.endPointEx.title}}</h1>
<div mat-dialog-content style="height: 600px">
  <mat-tab-group>
    <mat-tab label="Add. Data" *ngIf="data.endPointEx.subData && data.endPointEx.subData.length > 0">
      <mat-card class="tight-card">
        <mat-card-title>Additional Data</mat-card-title>
        <mat-card-content>
          <p><i>Note: Destination folder names only apply to destinations that support folder structures (e.g., S3, Azure Blob, SFTP).</i></p>
          <div *ngFor="let dataItem of additionalData" class="tight-list-item">
            <div style="width: 242px">
              <mat-checkbox [(ngModel)]="dataItem.selected" (change)="rebuildGroupedColumns()">
                <span class="item-title">{{dataItem.title}}</span>
              </mat-checkbox>
            </div>
            <div style="flex: 1; margin-left: 10px" *ngIf="dataItem.selected">
              <input class="folder-input full-width" [placeholder]="dataItem.defaultOutputFolderName || ''" [(ngModel)]="dataItem.outputFolderName" />
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    <mat-tab label="Dimensions" *ngIf="data.endPointEx.dimensions && data.endPointEx.dimensions.length > 0">
      <mat-card class="tight-card">
        <mat-card-title>Dimensions</mat-card-title>
        <mat-card-content>
          <div *ngFor="let dimension of dimensions" class="tight-list-item">
            <mat-checkbox [(ngModel)]="dimension.selected" [matTooltip]="dimension.title" matTooltipShowDelay="500">
              <span class="item-title">{{dimension.title}}</span>
            </mat-checkbox>
            <span class="item-description" *ngIf="dimension.description" [matTooltip]="dimension.description" matTooltipShowDelay="500">- {{dimension.description}}</span>
            <span class="item-description" *ngIf="!dimension.description"></span>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    <mat-tab label="Measures" *ngIf="data.endPointEx.measures && data.endPointEx.measures.length > 0">
      <mat-card class="tight-card">
        <mat-card-title>Measures</mat-card-title>
        <mat-card-content>
          <div *ngFor="let measure of measures" class="tight-list-item">
            <mat-checkbox [(ngModel)]="measure.selected" [matTooltip]="measure.title" matTooltipShowDelay="500" (change)="measureSelected(measure)">
              <span class="item-title">{{measure.title}}</span>
            </mat-checkbox>
            <span class="item-description">
              <span *ngIf="measure.description" [matTooltip]="measure.description" matTooltipShowDelay="500">- {{measure.description}}</span>
              <span *ngIf="!measure.description"></span>
            </span>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    <mat-tab label="Columns" *ngIf="data.endPointEx.columns && data.endPointEx.columns.length > 0">
      <mat-card class="tight-card">
        <mat-card-title>Columns</mat-card-title>
        <mat-card-content>
          <p><i>Note: Selecting no columns will show all of them.</i></p>
          <div *ngFor="let group of groupedColumns">
            <mat-checkbox [checked]="isGroupSelected(group)" [indeterminate]="isGroupIndeterminate(group)" (change)="toggleGroupSelection(group, $event)">
              <span class="columns-group-header">{{group.group}}</span>
            </mat-checkbox>
            <div style="margin-left: 20px;" class="columns-group-container">
              <div *ngFor="let column of group.columns" class="tight-list-item">
                <mat-checkbox [(ngModel)]="column.selected" [matTooltip]="column.name" matTooltipShowDelay="500">
                  <span class="item-title">{{column.name}}</span>
                </mat-checkbox>
                <span class="item-description" *ngIf="column.description" [matTooltip]="column.description" matTooltipShowDelay="500">- {{column.description}}</span>
                <span class="item-description" *ngIf="!column.description"></span>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    <mat-tab label="Output">
      <mat-card class="tight-card">
        <mat-card-title>Output Settings</mat-card-title>
        <mat-card-content>
          <p><i>Note: Destination folder names only apply to destinations that support folder structures (e.g., S3, Azure Blob, SFTP).</i></p>
          <mat-form-field class="full-width">
            <mat-label>Endpoint Output Folder</mat-label>
            <input matInput [(ngModel)]="data.endPoint.outputFolderName" [placeholder]="data.endPointEx.defaultOutputFolderName || ''" />
            <mat-hint *ngIf="data.endPointEx.defaultOutputFolderName">Default: {{data.endPointEx.defaultOutputFolderName}}</mat-hint>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onSave()">Apply Changes</button>
  <button mat-raised-button class="piButton" (click)="onCancel()">Cancel</button>
</div>
